import axios from 'axios';
import _ from 'lodash';
import { API_ROUTES } from '../constants';
import { Waiver } from '../../js/types/waiver';

const WaiverService = {
  getWaivers: (maxPublishedDaysOld = 30, airlineCode = ''): Promise<any> => {
    return axios.get(
      `${API_ROUTES.waivers}?maxPublishedDaysOld=${maxPublishedDaysOld}&issuingAirlineCodes=${airlineCode}`
    );
  },

  getWaiverVersions: (waiverId: string): Promise<any> => {
    const url = API_ROUTES.waiver.replace(':waiverId', waiverId);
    return axios.get(url);
  },

  upsertWaiver: (waiver: Waiver): Promise<any> => {
    return axios.post(API_ROUTES.waivers, waiver);
  },

  deleteWaiver: (waiverId: string): Promise<any> => {
    const url = API_ROUTES.waiver.replace(':waiverId', waiverId);
    return axios.delete(url);
  },

  getWaiverConfiguration: (airlineCode: string): Promise<any> => {
    const url = API_ROUTES.waiverConfiguration.replace(':airlineCode', airlineCode);
    return axios.get(url);
  },

  upsertWaiverConfiguration: (waiverConfig: any): Promise<any> => {
    return axios.post(API_ROUTES.waiverConfigurations, waiverConfig);
  },

  getAirlines: (): Promise<any> => {
    return axios.get(API_ROUTES.waiverAirlines);
  },
};

export default WaiverService;